import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import * as screenfull from 'screenfull';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  viewMode?: boolean;

  constructor(private cookieService: CookieService, private router: Router) {
  }


  public getViewMode(): boolean {
    const viewModeStr: string = this.cookieService.get('viewMode');
    this.viewMode = 'true' === viewModeStr;
    return this.viewMode;
  }

  switchViewMode() {
    this.viewMode = !this.viewMode;
    this.cookieService.set('viewMode', '' + this.viewMode);

    if (this.viewMode) {
      // this.router.navigate(['/']);
      if (screenfull.request != null) {
        screenfull.request();
      }
    } else {
      if (screenfull.isFullscreen != null && screenfull.toggle != null && screenfull.isFullscreen) {
        screenfull.toggle();
      }
    }
  }
}
